import { render, staticRenderFns } from "./demandFive.vue?vue&type=template&id=2aee9a82&scoped=true"
import script from "./demandFive.vue?vue&type=script&lang=js"
export * from "./demandFive.vue?vue&type=script&lang=js"
import style0 from "./demandFive.vue?vue&type=style&index=0&id=2aee9a82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aee9a82",
  null
  
)

export default component.exports